import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";
import { FadeUp, SectionLabel } from "./Reveal";

const STATS = [
  { value: 6, suffix: "", label: "Ventures & Growing" },
  { value: 100, suffix: "+", label: "Projects Delivered" },
  { value: 20, suffix: "K+", label: "Users & Traders Worldwide" },
  { value: 24, suffix: "/7", label: "AI Operations, Always On" },
];

const Counter = ({ value, suffix }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const duration = 1600;
    const start = performance.now();
    let raf;
    const tick = (now) => {
      const p = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setDisplay(Math.round(eased * value));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, value]);

  return (
    <span ref={ref} className="font-display text-5xl font-extrabold tracking-tight text-white sm:text-6xl">
      {display}
      <span className="text-gradient-cyan">{suffix}</span>
    </span>
  );
};

export const Stats = () => (
  <section id="numbers" data-testid="stats-section" className="relative py-24 md:py-32">
    <div className="mx-auto max-w-[1440px] px-6 md:px-12">
      <FadeUp>
        <SectionLabel>The Numbers</SectionLabel>
      </FadeUp>
      <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {STATS.map((s, i) => (
          <FadeUp key={s.label} delay={i * 0.1}>
            <div
              data-testid={`stat-${i}`}
              className="rounded-2xl border border-white/10 bg-slate-950/60 p-8 backdrop-blur-xl transition-colors duration-300 hover:border-cyan-400/30"
            >
              <Counter value={s.value} suffix={s.suffix} />
              <p className="mt-3 font-mono-tech text-xs uppercase tracking-[0.2em] text-slate-400">
                {s.label}
              </p>
            </div>
          </FadeUp>
        ))}
      </div>
    </div>
  </section>
);
